<template>
  <div class="flex-grow-1 flex-column d-flex justify-center align-center">
    <p class="text-h6">
      {{ $t('app.pages.notFound.headers.thePageYouAreLookingForDoesNotExist') }}
    </p>
    <p>
      <router-link to="/appointments">
        {{ $t('app.pages.notFound.links.goBackToWarehousePortal') }}
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      robotsMeta: null
    };
  },
  mounted() {
    // Add meta tag so bots ignore any page where this component is rendered when component is mounted
    this.robotsMeta = document.createElement('meta');
    this.robotsMeta.name = 'robots';
    this.robotsMeta.content = 'noindex';

    document.head.appendChild(this.robotsMeta);
  },
  unmounted() {
    // Remove the meta tag this component appended
    this.robotsMeta?.remove();
    this.robotsMeta = null;
  }
};
</script>
